export default __webpack_public_path__ + "static/media/date_left_icon.8fbeaa4e.svg";